import Validator from 'arbitrip-common/client/utils/Validator';

class TravelersHelper {
    MATMID_REGEXP = /^\d{6,9}$/;

    MATMID_LIMITS = {
        MAX_LENGTH: 9,
        MIN_LENGTH: 6,
    };

    updateTravelerFullName(traveler) {
        if (traveler.first_name && traveler.last_name) {
            traveler.full_name = traveler.first_name + ' ' + traveler.last_name;
        } else {
            traveler.full_name = '';
        }

        return traveler;
    }

    getValidNameExcludingForbiddenChars(name) {
        if (!name) {
            return '';
        }

        const result = name.toString().trim().replace(Validator.REGEXES.non_clear_english_only_regex, '');

        return result;
    }

    getValidFirstName(name, isElal = false) {
        const trimmedName = name.trim();
        const isValid = isElal
            ? Validator.validateClearEnglishOnly(trimmedName)
            : Validator.validateEnglishOnly(trimmedName);
        return isValid && trimmedName.length > 1;
    }

    getValidLastName(name, isElal = false) {
        const trimmedName = name.trim();
        const isValid = isElal
            ? Validator.validateClearEnglishOnly(trimmedName)
            : Validator.validateEnglishOnly(trimmedName);
        return isValid && trimmedName.length > 1;
    }

    getValidEmail(email, isMandatory) {
        if (isMandatory) {
            return email && Validator.validateEmailAddress(email);
        } else {
            return !email || Validator.validateEmailAddress(email);
        }
    }

    getValidPhone(phone) {
        return phone && Validator.validatePhoneNumber(phone);
	}
	
	isFFMLengthValid(ffn) {
		if (!ffn) {
			return false;
		}

		if (ffn.trim().length < this.MATMID_LIMITS.MIN_LENGTH || ffn.trim().length > this.MATMID_LIMITS.MAX_LENGTH) {
            return false;
		}
		
		return true;
	}

	doesFFMRegExpMatch(ffn) {
		if (!ffn) {
			return false;
		}

		return this.MATMID_REGEXP.test(ffn.trim());
	}

    getValidFFN(ffn) {
        if (!ffn) return true;

        if (!this.isFFMLengthValid(ffn)) {
            return false;
        }

        return this.doesFFMRegExpMatch(ffn);
    }

    getValidationResults(traveler, isMandatory, isElal = false) {
        let validFirstName = this.getValidFirstName(traveler?.first_name ?? '', isElal);
        let validLastName = this.getValidLastName(traveler?.last_name ?? '', isElal);
        let validEmail = this.getValidEmail(traveler?.email ?? '', isMandatory);
        let validPhone = this.getValidPhone(traveler?.phone?.replaceAll(' ', '').trim());
        let validFFN = this.getValidFFN(traveler?.frequent_flyer_number ?? '');

        return {
            validFirstName,
            validLastName,
            validEmail,
            validPhone,
            validFFN,
        };
    }

    isValidTraveler(traveler, isElal = false) {
        const { validFirstName, validLastName, validEmail } = this.getValidationResults(traveler, false, isElal);

        return validFirstName && validLastName && validEmail;
    }
}

export default new TravelersHelper();
